import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HybridProPanelHelper } from '../hybrid-pro-panel.helper';

@Pipe({
  name: 'hybridProOperatingModesActive',
  standalone: true,
})
export class HybridProOperatingModesActivePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: string): string {
    if (value === HybridProPanelHelper.SecondaryHeatGeneratorOperatingModesActive.Fixed) {
      return this.translate.instant(
        '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.CONTROL_STRATEGY.FIXED'
      );
    } else if (
      value === HybridProPanelHelper.SecondaryHeatGeneratorOperatingModesActive.Economical
    ) {
      return this.translate.instant(
        '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.CONTROL_STRATEGY.ECONOMICAL'
      );
    } else if (
      value === HybridProPanelHelper.SecondaryHeatGeneratorOperatingModesActive.Ecological
    ) {
      return this.translate.instant(
        '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.CONTROL_STRATEGY.ECOLOGICAL'
      );
    } else if (value === HybridProPanelHelper.SecondaryHeatGeneratorOperatingModesActive.Off) {
      return this.translate.instant(
        '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.CONTROL_STRATEGY.OFF'
      );
    } else if (value === HybridProPanelHelper.SecondaryHeatGeneratorModes.MonovalentOperation) {
      return this.translate.instant(
        '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.CONTROL_MODE.MONOVALENT_OPERATION'
      );
    } else if (value === HybridProPanelHelper.SecondaryHeatGeneratorModes.BivalentParallel) {
      return this.translate.instant(
        '+INSTALLATIONS.INSTALLATION.PANEL.HYBRID_PRO.CONTROL_MODE.BIVALENT_PARALLEL'
      );
    } else {
      return value;
    }
  }
}
